import React, { useState } from "react";
import { ChartColumn, UserPlus } from "lucide-react";
import Pipeline from "./Pipeline";
import CandidateBoard from "./CandidateBoard";
import Request from "./Request";
import CustomTabs from "components/tabs/customTab";

const RecruitmentOverviewTabs = () => {
    const [activeTab, setActiveTab] = useState("Pipeline");
    
    const TabLabel = ({ icon: Icon, text }) => (
    <div className="flex items-center justify-center gap-2">
        <Icon className="text-gray-800 w-4 h-4" />
        <span className="text-sm font-medium">{text}</span>
    </div>
    );

    const tabOptions = [
        { label: <TabLabel icon={ChartColumn} text="Pipeline" />, value: "Pipeline" },
        { label: <TabLabel icon={UserPlus} text="Request" />, value: "Request" },
    ];


    return (
        <div className="space-y-6">
            <CustomTabs
                tabs={tabOptions}
                activeTab={activeTab}
                onChange={setActiveTab}
            />

            <>
                {activeTab === "Pipeline" && (
                    <>
                        <Pipeline />
                        <CandidateBoard />
                    </>
                )}

                {activeTab === "Request" && (
                    <>
                        <Request />
                    </>
                )}
            </>
        </div>
    );
};

export default RecruitmentOverviewTabs;
